import {
  ICapabilityPage as IContentfulCapabilityPage,
  IEntry,
} from 'marketing-site/@types/generated/contentful'
import { ICapabilityPage } from 'marketing-site/src/components/common/pages/CapabilityPage'
import { transformCapability } from '../models/ContentfulCapability'
import { transformHyperlink } from '../models/ContentfulHyperlink'

export function isCapabilityPage(entry: IEntry): entry is IContentfulCapabilityPage {
  return entry.sys.contentType?.sys.id === 'capabilityPage'
}

export function transformCapabilityPage({ fields }: IContentfulCapabilityPage): ICapabilityPage {
  return {
    ...fields,
    capability: transformCapability(fields.capability),
    primaryLink: transformHyperlink(fields.primaryLink),
    footerLink: transformHyperlink(fields.footerLink),
  }
}
